import { parseProject, PROJECT_STORAGE_KEY } from '~/utils/project';
export default defineNuxtPlugin(() => {
  const { project, saveState } = useProjectPlanner();
  onNuxtReady(() => {
    try {
      const stored = localStorage.getItem(PROJECT_STORAGE_KEY);
      if (stored) project.value = parseProject(JSON.parse(stored));
      saveState.value = 'saved';
    } catch {
      saveState.value = 'unavailable';
    }
    let timer: ReturnType<typeof setTimeout>;
    const save = () => {
      try {
        localStorage.setItem(PROJECT_STORAGE_KEY, JSON.stringify(project.value));
        saveState.value = 'saved';
      } catch {
        saveState.value = 'unavailable';
      }
    };
    watch(
      project,
      () => {
        saveState.value = 'saving';
        clearTimeout(timer);
        timer = setTimeout(save, 400);
      },
      { deep: true },
    );
    save();
    window.addEventListener('pagehide', save);
  });
});
